import React, { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';

interface ReadOnlyTextViewProps {
    textContent: string;
    textHeader: string;
    textContentStyle?: CSSProperties;
    textHeaderStyle?: CSSProperties;
}

const containerStyle: CSSProperties = {
    display: 'grid',
    backgroundColor: 'transparent',
    gridTemplateColumns: '1fr',
};

const defaultTextContentStyle: CSSProperties = {
    fontSize: 20,
    fontWeight: Size.FontWeight.Regular,
    color: Color.DARK_GRAY,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};

const defaultTextHeaderStyle: CSSProperties = {
    fontSize: 15,
    fontWeight: Size.FontWeight.ExtraBold,
    color: Color.DARK_GRAY,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};

export const ReadOnlyTextView = ({ textContent, textHeader, textContentStyle, textHeaderStyle }: ReadOnlyTextViewProps) => (
    <div style={containerStyle}>
        <div style={{ ...defaultTextHeaderStyle, ...textHeaderStyle }} title={textHeader}>
            {textHeader}
        </div>
        <div style={{ ...defaultTextContentStyle, ...textContentStyle }} title={textContent}>
            {textContent}
        </div>
    </div>
);
